import { MAX_ATTEMPTS, WORD_LENGTH } from "@mk/shared";
import { Sheet } from "./Sheet.tsx";
import { messages } from "../i18n/index.ts";

interface HowToPlayProps {
  open: boolean;
  onClose: () => void;
}

const EXAMPLE_STATES = [
  { index: 0, state: "correct" as const },
  { index: 2, state: "present" as const },
  { index: 4, state: "absent" as const },
];

export function HowToPlay({ open, onClose }: HowToPlayProps) {
  return (
    <Sheet open={open} title={messages.howTo.title} onClose={onClose}>
      <p className="text-sm leading-relaxed text-muted">
        {messages.howTo.intro(WORD_LENGTH, MAX_ATTEMPTS)}
      </p>

      <ul className="howto-list">
        {messages.howTo.examples.map((example, exampleIndex) => {
          const presentation = EXAMPLE_STATES[exampleIndex]!;
          return (
          <li key={example.word} className="howto-card" data-state={presentation.state}>
            <div className="howto-word" aria-label={example.word}>
              {[...example.word].map((letter, i) => (
                <span
                  key={i}
                  className="howto-tile"
                  data-state={i === presentation.index ? presentation.state : undefined}
                >
                  {letter}
                </span>
              ))}
            </div>
            <div>
              <strong className="howto-card__label">{example.label}</strong>
              <p className="howto-card__text">{example.text}</p>
            </div>
          </li>
          );
        })}
      </ul>
    </Sheet>
  );
}
